import React from 'react';
import { Dialog } from '@mui/material';
import { ReactComponent as Done } from "../../../../../../../assets/img/svg/done-bullet.svg"
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg"
import AButton from '../../../../common/form-fields-mui/AButton';
import styles from "../styles.module.scss"

const ReceiptCreationSuccessDialog = ({ open, closeHandler, pserpReceiptId }) => {
    return (

        <Dialog
            open={open}
        >
            <div className={styles['dialog-padding']}>

                <div className='d-flex justify-content-between'>

                    <Done className={styles['dialog-done-icon']}/>
                    <CrossIcon onClick={closeHandler} className={styles['dialog-cross-icon']} />

                </div>

                <div className={`mt-3 ${styles['verify-details-dialog-header']}`}>Receipt has been generated</div>
                <div className={`${styles['cancel-collection-dialog-sub-header']}`}>Receipt ID : {pserpReceiptId}</div>

                <AButton
                    variant='primary_filled'
                    onClick={closeHandler}
                    className='no-ml-btn mt-3'
                >
                    Okay
                </AButton>
            </div>

        </Dialog>

    );
}

export default ReceiptCreationSuccessDialog;